import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import ErrorBoundary from "./components/ErrorBoundary";
import { TimezoneProvider } from "./context/TimezoneContext";
import { Toaster } from "./components/ui";
import Layout from "./components/Layout";
import { PageLoader } from "./components/ui";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Contacts from "./pages/Contacts";
import ContactDetail from "./pages/ContactDetail";
import Agents from "./pages/Agents";
import Analytics from "./pages/Analytics";
import ActivityLogs from "./pages/ActivityLogs";
import Upload from "./pages/Upload";
import AdminPanel from "./pages/AdminPanel";
import LeadRelay from "./pages/LeadRelay";
import EmailClient from "./pages/EmailClient";
import CallBar from "./components/CallBar";

function Protected({ children, adminOnly, uploadOnly }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) return <div className="h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0B0F19]"><PageLoader /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/dashboard" replace />;
  if (uploadOnly && !user.is_admin && !user.can_upload) return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/leads" element={<Protected><Contacts type="lead" /></Protected>} />
      <Route path="/leads/:id" element={<Protected><ContactDetail type="lead" /></Protected>} />
      <Route path="/clients" element={<Protected><Contacts type="client" /></Protected>} />
      <Route path="/clients/:id" element={<Protected><ContactDetail type="client" /></Protected>} />
      <Route path="/analytics" element={<Protected adminOnly><Analytics /></Protected>} />
      <Route path="/activity-logs" element={<Protected><ActivityLogs /></Protected>} />
      <Route path="/upload" element={<Protected uploadOnly><Upload /></Protected>} />
      <Route path="/agents" element={<Protected adminOnly><Agents /></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><AdminPanel /></Protected>} />
      <Route path="/relay" element={<Protected adminOnly><LeadRelay /></Protected>} />
      <Route path="/email" element={<EmailClient />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <TimezoneProvider>
        <AuthProvider>
          <BrowserRouter>
            {/* Around the routes, not the providers: a screen that throws must
                not take the whole app down with it. */}
            <ErrorBoundary>
              <AppRoutes />
            </ErrorBoundary>
            <CallBar />
            <Toaster />
          </BrowserRouter>
        </AuthProvider>
      </TimezoneProvider>
    </ThemeProvider>
  );
}
